"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const http_1 = __importDefault(require("http"));
const https_1 = __importDefault(require("https"));
const url = __importStar(require("url"));
exports.empty = (val) => (val === undefined || val === null || val === '' || val === 'null');
exports.rand = (max) => Math.floor(Math.random() * max) + 1;
exports.randStr = (length) => {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i += 1) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
};
const defaultOptions = {
    path: '/',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
    },
    useTls: true
};
exports.httpRequest = (opts) => new Promise((resolve, reject) => {
    console.log(opts.path);
    const u = url.parse(opts.path);
    if (opts.hostname === undefined || opts.hostname === null) {
        opts.hostname = u.host;
    }
    if (opts.port === undefined || opts.port === null) {
        opts.port = u.port;
    }
    const options = Object.assign(defaultOptions, opts);
    const useHttp = (options.useTls ? https_1.default : http_1.default);
    const postData = (options.data !== undefined ? JSON.stringify(options.data) : null);
    if (postData !== null) {
        options.headers['Content-Length'] = postData.length;
    }
    const req = useHttp.request(options, (res) => {
        let data = '';
        res.on('data', (d) => {
            data += d;
        });
        res.on('end', () => {
            const response = {
                statusCode: res.statusCode,
                headers: res.headers,
                data,
            };
            resolve(response);
        });
    });
    req.on('error', ((err) => reject(err)));
    if (postData !== null) {
        req.write(postData);
    }
    req.end();
});
exports.addMicroDust = (num) => {
    return num - Math.pow(2, (Math.log2(num) - 52));
};
